import { createRouter, createWebHistory } from 'vue-router'
import Welcome from '@/components/Welcome.vue'
import Games from '@/components/Games.vue'
import Contact from '@/components/Contact.vue'
import SqueezePage from '@/components/SqueezePage.vue'
import Privacy from '../components/Privacy.vue'

const routes = [
  {
    path: '/',
    name: 'Welcome',
    component: Welcome
  },
  {
    path: '/games',
    name: 'Games',
    component: Games
  },
  {
    path: '/contact',
    name: 'Contact',
    component: Contact
  },
  {
    path: '/sp',
    name: 'SP',
    component: SqueezePage
  },
  {
    path: '/privacy',
    name: 'Privacy',
    component: Privacy
  }
]

const router = createRouter({ history: createWebHistory(), routes })
export default router